import { Box, Typography } from '@mui/material';
import moment from 'moment';

interface MaintenanceInfoProps {
  liveData: Record<string, any>;
}

const readableKeys: Record<string, string> = {
  Name: 'Name',
  DailyTimeRange: 'Daily Time Range',
  WeeklyTimeRange: 'Weekly Time Range',
  WeeklyDays: 'Weekly Days',
  MonthlyTimeRange: 'Monthly Time Range',
  MonthlyDay: 'Monthly Day',
  StartDate: 'Start Date',
  EndDate: 'End Date',
};

const MaintenanceInfo: React.FC<MaintenanceInfoProps> = ({ liveData }) => {

  const pauseTypes = ['daily', 'weekly', 'monthly', 'date_range'];

  return (
    <Box bgcolor="background.paper" boxShadow={1} borderRadius={1} p={2} mt={2.5} minHeight="200px" maxHeight="200px" overflow="auto">
      {pauseTypes.map((type) => {
        const info = liveData[type];
        return (
          <Box key={type} mb={2}>
            <Typography variant="subtitle1" fontWeight="bold">
              {type.replace('_', ' ').replace(/\b\w/g, (l) => l.toUpperCase())}:
            </Typography>

            {info ? (
              <Box ml={1}>
                {/* Show Name if available */}
                {info.Name && (
                  <Typography variant="body2">
                    <strong>{readableKeys['Name']}:</strong> {info.Name}
                  </Typography>
                )}

                {/* For date_range, show formatted date and time */}
                {type === 'date_range' ? (
                  (() => {
                    const formattedStartDate = info?.StartDate
                      ? moment(info.StartDate).format('DD-MM-YYYY')
                      : null;
                    const formattedStartTime = info?.StartDate
                      ? moment(info.StartDate).format('HH:mm:ss')
                      : null;
                    const formattedEndDate = info?.EndDate
                      ? moment(info.EndDate).format('DD-MM-YYYY')
                      : null;
                    const formattedEndTime = info?.EndDate
                      ? moment(info.EndDate).format('HH:mm:ss')
                      : null;

                    return (
                      <Typography variant="body2">
                        <strong>Date Range:</strong>{' '}
                        {formattedStartDate && formattedStartTime && formattedEndDate && formattedEndTime ? (
                          <span>
                            {formattedStartDate} {formattedStartTime} to {formattedEndDate} {formattedEndTime}
                          </span>
                        ) : (
                          'N/A'
                        )}
                      </Typography>
                    );
                  })()
                ) : (
                  // Fallback for other types
                  Object.entries(info).map(([key, val]) => {
                    if (key === 'Name') return null; // Already shown above
                    return (
                      <Typography key={key} variant="body2">
                        <strong>{readableKeys[key] ?? key}:</strong>{' '}
                        {(() => {
                          if (Array.isArray(val)) return val.join(', ');
                          if (typeof val === 'string' || typeof val === 'number') return val.toString();
                          return '';
                        })()}
                      </Typography>
                    );
                  }
                  )
                )}
              </Box>
            ) : (
              <Typography variant="body2" ml={1}>
                No Monitoring
              </Typography>
            )}
          </Box>
        );
      })}
    </Box>
  );
};

export default MaintenanceInfo;
